function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.228 3.041c2.473-.24 2.657-.433 2.885-3.041.229 2.608.413 2.8 2.887 3.041-2.474.24-2.659.435-2.887 3.041-.228-2.606-.412-2.802-2.885-3.04zm3.905 2.64c.087.993.158 1.067 1.1 1.159-.942.09-1.013.166-1.1 1.16-.085-.994-.156-1.07-1.099-1.16.943-.092 1.014-.166 1.1-1.159zm-3.418-.387c-.057-.646-.103-.693-.715-.754.612-.06.658-.107.715-.752.056.645.102.693.715.752-.613.06-.659.108-.715.754zm-3.58 3.388c.383-.523.888-.732 1.377-.732h-.001c.122 0 .243.018.366.052 1.098.28 1.428 1.55 1.428 2.75 0 1.428-.575 2.838-1.881 2.838-.435 0-.889-.191-1.202-.522-.348-.383-.645-1.097-.645-2.246 0-.852.173-1.636.558-2.14zm-.488-1.828a4.67 4.67 0 00-.26.296v-.853H7V18.5h2.699v-3.742l.039.024c.695.424 1.218.742 2.208.742 3.12 0 3.94-2.892 3.94-4.753 0-3.029-1.726-4.715-3.956-4.715-1.01 0-1.83.362-2.283.798z"
  }));
};
const SvgPricelineSparkle = styled(BaseComponent).withConfig({
  displayName: "PricelineSparkle__SvgPricelineSparkle",
  componentId: "sc-1vf2hzw-0"
})(["outline:none;"]);
SvgPricelineSparkle.isIcon = true;
export default SvgPricelineSparkle;